export const MAX_NOTE_CANVAS_HEIGHT = 800;
export const NOTE_CANVAS_HEIGHT_CHANGE_STEP = 150;
export const NOTE_CANVAS_HEIGHT_CHANGE_TRIGGER = 50;

export const noteBodyStyle = {
    paddingBottom: 18,
    paddingTop: 18,
    paddingLeft: 24,
    paddingRight: 24,
};

export const placeholderBodyStyle = {
    paddingBottom: 9,
    paddingTop: 9,
    paddingLeft: 12,
    paddingRight: 12,
};
